var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.431 12.658C36.31 9.762 36.31 5.068 33.431 2.172C32.7486 1.48385 31.9367 0.937646 31.0422 0.564897C30.1476 0.192148 29.1881 0.000236511 28.219 0.000236511C27.2499 0.000236511 26.2904 0.192148 25.3958 0.564897C24.5013 0.937646 23.6894 1.48385 23.007 2.172L17.795 7.415L22.991 12.642L23.007 12.658C23.6885 13.3454 24.4994 13.8913 25.3927 14.2641C26.2861 14.6369 27.2444 14.8293 28.2124 14.8302C29.1805 14.8312 30.1391 14.6406 31.0332 14.2695C31.9273 13.8984 32.7391 13.3541 33.422 12.668L33.432 12.658H33.431Z",
    fill: "url(#paint0_linear_2_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.371 17.902L2.16 12.658C-0.719002 9.763 -0.719002 5.068 2.16 2.172C2.84237 1.48385 3.65425 0.937646 4.54881 0.564897C5.44337 0.192148 6.40289 0.000236511 7.372 0.000236511C8.34111 0.000236511 9.30063 0.192148 10.1952 0.564897C11.0897 0.937646 11.9016 1.48385 12.584 2.172L17.796 7.415L7.371 17.902Z",
    fill: "#17DA88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.431 12.658C32.7473 13.3475 31.9336 13.8945 31.037 14.2673C30.1404 14.6401 29.1787 14.8313 28.2077 14.8298C27.2366 14.8284 26.2756 14.6342 25.3801 14.2587C24.4846 13.8831 23.6726 13.3336 22.991 12.642L17.795 7.415L7.371 17.902L10.349 20.897C11.3238 21.8801 12.4837 22.6605 13.7617 23.193C15.0397 23.7255 16.4105 23.9997 17.795 23.9997C19.1795 23.9997 20.5503 23.7255 21.8283 23.193C23.1063 22.6605 24.2662 21.8801 25.241 20.897L33.431 12.658V12.658Z",
    fill: "url(#paint1_linear_2_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 36.4348,
    y1: 6.93697,
    x2: 14.9814,
    y2: 8.13844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2936A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#162286"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2",
    x1: 2.36722,
    y1: 16.8849,
    x2: 30.982,
    y2: 8.66039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2297F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A0F9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVero);
export default __webpack_public_path__ + "static/media/vero.cbf5b2f8c9739ba808a8b4813ec582fd.svg";
export { ForwardRef as ReactComponent };